var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnCheckboxOff = function SvgBtnCheckboxOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 2.75,
    width: 18.5,
    height: 18.5,
    rx: 1.25,
    fill: "#fff",
    stroke: "#C6C8CC",
    strokeWidth: 1.5
  })));
};
export default SvgBtnCheckboxOff;